<template>
  <custom-dialog width="800px" :title="model.title" :visible="visible" v-on="$listeners" appendToBody>
    <div class="location-transferDevice-dialog">
      <div class="ub" style="height: 480px">
        <div class="ub-f1 ubv" style="padding-right: 24px">
          <div class="tit">{{ $t('dms_location_transferDevice_dialog.xiang_mu') }}</div>
          <div style="padding-bottom: 16px">
            <search-input width="100%" :placeholder="$t('dms_location_transferDevice_dialog.xiang_mu_ming_cheng')" v-model="appKey" @fetch="filterLocation"></search-input>
          </div>
          <ul class="list ub-f1">
            <li :class="[{ cur: locationData &&locationData.locationId === item.locationId }]" v-for="(item, index) in locationFilter" :key="index" @click="handleNodeClick(item)" class="ub">
              <div class="name line1 ub-f1">{{ item.locationName|| '-'  }}</div>
            </li>
          </ul>
        </div>
        <div style="width: 1px; background: #f5f5f5"></div>
        <div class="ub-f1 ubv" style="padding-left: 24px">
          <div class="tit">{{ $t('dms_location_transferDevice_dialog.qu_yu') }}</div>
          <div style="padding-bottom: 16px">
            <search-input width="100%" :placeholder="$t('dms_location_transferDevice_dialog.qu_yu_ming_cheng')" v-model="appKey1" @fetch="filterSite"></search-input>
          </div>
          <ul class="list ub-f1">
            <li :class="[{ cur: siteData.siteId === item.siteId }]" v-for="(item, index) in siteFilter" :key="index" @click="handleSiteClick(item)" class="ub">
              <div class="name line1 ub-f1">{{ item.siteName || '-' }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="info">
        <span style="color: #4d4d4d">{{  locationData &&locationData.locationName }}</span>
        <span v-if="siteData.siteName">&ensp;>&ensp;{{ siteData.siteName }}</span>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" :disabled="!siteData.siteId" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import searchInput from '@/components/searchInput.vue';

export default {
  mixins: [dialogMixins],
  components: {
    searchInput,
  },
  data() {
    return {
      appKey: '',
      appKey1: '',
      locationData: {},
      locationList: [],
      locationFilter: [],
      siteData: {},
      siteList: [],
      siteFilter: [],
    };
  },

  mounted() {
    this.getLocatonList();
    if (this.model.data.locationId) {
      this.locationData.locationId = this.model.data.locationId;
      this.getSiteList();
    }
    if (this.model.data.siteId) {
      this.siteData.siteId = this.model.data.siteId;
    }
  },
  methods: {
    // 确认保存
    confirm: function () {
      this.$postJSON(apis.locationDeviceAssociate, {
        deviceIdList: this.model.tableSelect.map(t => t.deviceId),
        toBizId: this.siteData.siteId || this.locationData.locationId,
        toBizType: this.siteData.siteId ? 3 : 1,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 获取项目列表
    getLocatonList: function () {
      this.$getJSON(apis.locationList, {
        orgId: this.model.data.orgId,
        isAll: true
      }).then((res) => {
        this.locationList = res.data;
        this.filterLocation();
        if (this.locationData.locationId) {
          this.locationData = this.locationList.find(i => i.locationId === this.locationData.locationId);
        }
      });
    },
    // 项目列表过滤
    filterLocation: function () {
      if (!this.appKey) {
        this.locationFilter = this.locationList;
        return;
      }
      this.locationFilter = this.locationList.filter(t => t.locationName.includes(this.appKey));
    },
    // 选中项目
    handleNodeClick: function (item) {
      this.locationData = item;
      this.siteData = {};
      this.getSiteList();
    },
    // 获取站点
    getSiteList: function () {
      this.$getJSON(apis.locationSiteAllList, {
        locationId: this.locationData.locationId,
      }).then((res) => {
        this.siteList = res.data;
        this.filterSite();
        if (this.siteData.siteId) {
          this.siteData = this.siteList.find(i => i.siteId === this.siteData.siteId);
        }
      });
    },
    // 站点列表过滤
    filterSite: function () {
      if (!this.appKey1) {
        this.siteFilter = this.siteList;
        return;
      }
      this.siteFilter = this.siteList.filter(t => t.siteName.includes(this.appKey1));
    },
    // 选中站点
    handleSiteClick: function (data) {
      this.siteData = { ...data };
    },
  },
};
</script>

<style lang="scss">
.location-transferDevice-dialog {
  padding: 24px;
  .tit {
    // color: $--color-text-regular;
    margin-bottom: 16px;
    font-weight: bold;
    line-height: 20px;
    font-size: 14px;
  }
  .info {
    margin-top: 24px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #00a0d9;
    font-weight: bold;
  }
  .list {
    overflow-y: auto;
    > li {
      height: 40px;
      line-height: 39px;
      cursor: pointer;
      padding-right: 12px;
      border: 1px solid transparent;
      .box {
        width: 38px;
        text-align: center;
        color: #00a0d9;
        .icon {
          font-size: 16px;
        }
      }
      .name {
        // color: $--color-text-regular;
        font-size: 14px;
        padding-left: 12px;
      }
      &.cur {
        border: 1px solid #00a0d9;
        border-radius: 8px;
        box-sizing: border-box;
        background: #f8f9fa;
        .name {
          color: #00a0d9;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
